import React, { useEffect, useState } from "react";
import { GetEventUsersService } from "../../../../apis/events";
import { useParams } from "react-router-dom";
import { Table } from "../../../../components/ui";
import { Button, Input, Tooltip } from "antd";

export default function EventUsers() {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const getEventUsers = async (query = "") => {
    setLoading(true);
    try {
      const payload = { event_id: id };
      if (query && query.trim() !== "") payload.search = query.trim();
      const res = await GetEventUsersService(payload);
      if (res.status === 200) {
        concatCountryCode(res.data.success ? res.data.userlist : []);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const concatCountryCode = (list) => {
    const mapped = (list || []).map((item) => ({
      ...item,
      mobile_number: item?.mobile_number
        ? `${item.code}${item.mobile_number}`
        : item?.mobile_number,
    }));
    setData(mapped);
  };

  useEffect(() => {
    getEventUsers();
  }, []); // eslint-disable-line

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Mobile",
      dataIndex: "mobile_number",
      key: "mobile_number",
    },
    {
      title: "Photos Distributed (WhatsApp)",
      dataIndex: "send_images_to_user",
      key: "send_images_to_user",
    },
    {
      title: "Photos Distributed (Web)",
      dataIndex: "web_send_images_to_user",
      key: "web_send_images_to_user",
    },
    {
      title: "Downloads",
      dataIndex: "web_downloads",
      key: "web_downloads",
    },
    {
      title: "User Uploaded Photos",
      dataIndex: "receive_images_form_user",
      key: "receive_images_form_user",
    },
  ];

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h3 className="page-title m-0">Users</h3>
        <div className="d-flex align-items-center" style={{ gap: 8 }}>
          <Input
            allowClear
            placeholder="Search by name or mobile"
            style={{ width: 280 }}
            value={search}
            onChange={(e) => {
              const val = e.target.value;
              setSearch(val);
              if (val === "") {
                getEventUsers("");
              }
            }}
          />
          <Tooltip title="Apply filter">
            <Button
              type="default"
              icon={<i className="fa-solid fa-filter" />}
              onClick={() => getEventUsers(search)}
              loading={loading}
            />
          </Tooltip>
        </div>
      </div>
      <Table columns={columns} data={data} loading={loading} />
    </>
  );
}
